import { ChangeDetectorRef, Component, OnInit, effect, input, output, signal, viewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { HttpErrorResponse } from "node_modules/@angular/common/types/_module-chunk";
import { ControlPoint } from "src/app/bo/controlPoint";
import { Ponderation } from "src/app/bo/ponderation.model";
import { VibrationData } from "src/app/bo/vibrationsForChart/vibration-data";
import { VibrationRecord } from "src/app/bo/vibrationsForChart/vibration-record";
import { FonctionsService } from "src/app/services/fonctions-partagees.service";
import { PonderationService } from "src/app/services/ponderation.service";
import { VibrationsRecordService } from "src/app/services/vibrations-record.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-record-detail',
  templateUrl: './record-detail.component.html',
  styleUrls: ['./record-detail.component.scss'],
  standalone: false
})
export class RecordDetailComponent implements OnInit {
    readonly confirmDeleteModal = viewChild<ModalDirective>("confirmDeleteModal");
    readonly editDistanceModal = viewChild<ModalDirective>("editDistanceModal");
    readonly editNoteModal = viewChild<ModalDirective>("editNoteModal");
    readonly siteId = input<number>();
    readonly vibrationRecords = input<VibrationData[]>();
    readonly selectedRecordIndex = input<number>(0);
    readonly isDetailsVisible = input<boolean[]>();
    readonly recordsChanged = output<void>();
    localVibrationRecords = signal<VibrationData[]>([]);
    selectedTab = 'main';
    readonly controlPoints = input<ControlPoint[]>();
    currentControlPointId: number;
    selectedIndex: number | null = null;
    selectedRecordDistance: number | null = null;
    note1: string | null = null;
    note2: string | null = null;
    note3: string | null = null;
    isDownloading = signal(false);
    ponderations = signal<Ponderation[]>([]);
      selectedRecordIds: Set<number> = new Set<number>();
  pendingBulkDelete = false;

  get allSelected(): boolean {
    const records = this.vibrationRecords() ?? [];
    return records.length > 0 && records.every(r => this.selectedRecordIds.has(r.id));
  }

  toggleSelection(id: number): void {
    if (this.selectedRecordIds.has(id)) {
      this.selectedRecordIds.delete(id);
    } else {
      this.selectedRecordIds.add(id);
    }
  }

  toggleSelectAll(): void {
    if (this.allSelected) {
      this.selectedRecordIds.clear();
    } else {
      this.vibrationRecords()?.forEach(r => this.selectedRecordIds.add(r.id));
    }
  }
    constructor(private readonly vibrationsRecordService: VibrationsRecordService, private readonly cdr: ChangeDetectorRef,
      private readonly translate: TranslateService, private readonly fonctionsService: FonctionsService,
      private readonly ponderationService: PonderationService) {
      effect(() => {
        const records = this.vibrationRecords();
        if (records) {
          this.localVibrationRecords.set(records);
        }
      });
    }
  private readonly vibradataUrl = environment.vibradataFront;

  ngOnInit(): void {
    this.loadPonderations();
  }

  private loadPonderations(): void {
    this.ponderationService.getAllPonderations().subscribe({
      next: (response) => {
        this.ponderations.set(response.data);
      }
    });
  }

  pascalToDecibel(pressure: number): number | null {
    if(pressure == null) return null;
    const referencePressure = 20e-6;
    return 20 * Math.log10(pressure / referencePressure);
  }
  getRecord(record: VibrationData): VibrationRecord {
    let vibrationRecord: VibrationRecord = new VibrationRecord();
    vibrationRecord.information = {
      currentURL: window.location.href,
      regionName: ' ',
      siteName: ' ',
      controlPointName: '',
    };
    vibrationRecord.vibrationRecord = record;
    return vibrationRecord;
  }
  onNotesEdit(recordIndex: number) {
    let currentRecord = this.localVibrationRecords()[recordIndex];
    let vibrationRecord = this.getRecord(currentRecord);
    currentRecord.recordMetadata.note1 = this.note1;
    currentRecord.recordMetadata.note2 = this.note2;
    currentRecord.recordMetadata.note3 = this.note3;
    this.vibrationsRecordService.updateRecord(this.siteId(), vibrationRecord.vibrationRecord.id.toString(), vibrationRecord).subscribe({
        next: () => {
          this.fonctionsService.launch_toast(true);
          this.editNoteModal().hide();
        },
        error: (err: any) => {
        }
      });
  }
  onDistanceEdit(recordIndex: number): void {
    let currentRecord = this.localVibrationRecords()[recordIndex];
    let vibrationRecord = this.getRecord(currentRecord);
    currentRecord.distance = this.selectedRecordDistance;
    this.vibrationsRecordService.updateRecord(this.siteId(), vibrationRecord.vibrationRecord.id.toString(), vibrationRecord).subscribe({
        next: () => {
          this.fonctionsService.launch_toast(true);
          this.editDistanceModal().hide();
        },
        error: (err: any) => {
        }
      });
  }
  getControlPointName(controlPointId: number): string {       
     
    if (this.controlPoints() == undefined) {
      return '';
    }
    const controlPoint = this.controlPoints()?.find(cp => cp.controlPointId === controlPointId);
    if (controlPoint == undefined) {
      return '';
    }
    return controlPoint ? controlPoint.name : '';
  }
  toggleDetails(index: number): void {
    this.isDetailsVisible()[index] = !this.isDetailsVisible()[index];
    if (this.isDetailsVisible()[index]) {
      this.currentControlPointId = this.localVibrationRecords()[index].controlPointId;
      this.loadSignalData(index);
    }
  }
  private loadSignalData(index: number): void {
    if (!this.localVibrationRecords()[index].signalDataEntity) {
      const record = this.localVibrationRecords()[index];
      this.vibrationsRecordService.GetRecordById(this.siteId(), record.id).subscribe({
        next: (response) => {
          const updatedRecord = {
            ...record,
            signalDataEntity: response.data.signalDataEntity,
            timeSpectrumWeighted: response.data.timeSpectrumWeighted
          };
          this.updateVibrationRecords(index, updatedRecord);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.translate.get('MESSAGE_INFO.ERROR_LOADING_VIBRATION_RECORD').subscribe(
            (translation: string) => {
              console.error(translation, err);
            }
          );
        }
      });
    }
  }
  private updateVibrationRecords(index: number, updatedRecord: any): void {
    const current = this.localVibrationRecords();
    this.localVibrationRecords.set([
      ...current.slice(0, index),
      updatedRecord,
      ...current.slice(index + 1),
    ]);
  }
  setTab(tab: string): void {
    this.selectedTab = tab;
  }
  protected openConfirmDeleteModal(index: number) {
    this.selectedIndex = index;
    this.confirmDeleteModal().show();
  }
  protected openEditNoteModal(index: number) {
    this.selectedIndex = index;
    this.note1 = this.localVibrationRecords()[index].recordMetadata.note1;
    this.note2 = this.localVibrationRecords()[index].recordMetadata.note2;
    this.note3 = this.localVibrationRecords()[index].recordMetadata.note3;
    this.editNoteModal().show();
  }
  protected openEditDistanceModal(index: number) {
    this.selectedIndex = index;
    this.selectedRecordDistance = this.localVibrationRecords()[index].distance;
    this.editDistanceModal().show();
  }

  async deleteRecord(index: number): Promise<void> {
    let recordId = this.localVibrationRecords()[this.selectedIndex].id.toString();
    try {
          await this.vibrationsRecordService.deleteRecords(this.siteId(), recordId);
          this.localVibrationRecords.set(this.localVibrationRecords().filter(record => record.id.toString() !== recordId));
          this.fonctionsService.launch_toast(true);
          this.confirmDeleteModal().hide();
          this.isDetailsVisible()[index] = false;

      } catch  {
        this.translate.get('MESSAGE_INFO.RECORD_DELETED_ERROR').subscribe(
          (translation: string) => {
            this.fonctionsService.launch_toast(false,false, translation);
          }
        );
    }
  }
  seeRecordOnVibraData(recordIndex: number) {
    if(this.vibrationRecords() == undefined) {
      return;
    }
    const record = this.vibrationRecords()?.[recordIndex];
    const url = `${this.vibradataUrl}/vibration-detail?deviceId=${record?.recordMetadata.seismographSerialNumber}&siteId=${this.siteId()}&recordIndex=${recordIndex}`;
    window.open(url, '_blank');
  }
  openFile(vibrationRecord: VibrationData): void {
    if(vibrationRecord.recordMetadata == undefined || vibrationRecord.recordMetadata.seismographSerialNumber == undefined || vibrationRecord.recordMetadata.fileName == undefined) {
      return;
    }
    const  s3key = `Vibrations/${vibrationRecord.recordMetadata.seismographSerialNumber.toLowerCase()}/${vibrationRecord.recordMetadata.fileName}`;
    this.isDownloading.set(true);
    this.fonctionsService.loading_screen(true);
    this.vibrationsRecordService.getDownloadUrl(s3key).subscribe({
        next: (result) => {
            if (result && result.downloadUrl) {
              window.open(result.downloadUrl, '_blank');
              this.fonctionsService.loading_screen(false);
              this.isDownloading.set(false);
            }
        },
        error: (error: HttpErrorResponse) => {
        this.isDownloading.set(false);
        this.fonctionsService.loading_screen(false);
        },
      });
    
  }
      unassignRecord(vibrationRecord: VibrationData, type: string): void {
        let isBlast = type === 'blast';
        let errorMessage = 'Error unassigning blast';
    
        if (isBlast) {
          vibrationRecord.blastId = 0;
        }
    
        let data: VibrationRecord = {
          information: {
            currentURL: window.location.href,
            regionName: '',
            siteName: '',
            controlPointName: ''
          },
          vibrationRecord: vibrationRecord
        }
    
        this.vibrationsRecordService.updateRecord(this.siteId(), vibrationRecord.id.toString(), data).subscribe({
          next: () => {
            this.fonctionsService.launch_toast(true);
            this.recordsChanged.emit();
          },
          error: (err: any) => {
            console.error(errorMessage, err);
          }
        });
      }
  deleteSelected(): void {
    if (this.selectedRecordIds.size === 0) return;
    this.pendingBulkDelete = true;
    this.confirmDeleteModal().show();
  }

  async executeBulkDelete(): Promise<void> {
    this.confirmDeleteModal().hide();
    this.pendingBulkDelete = false;
    try {
      const ids = Array.from(this.selectedRecordIds);
      await this.vibrationsRecordService.deleteRecordsBulk(this.siteId(), ids);
      this.localVibrationRecords.set(
        this.localVibrationRecords().filter(r => !this.selectedRecordIds.has(r.id))
      );
      this.recordsChanged.emit();
      this.selectedRecordIds.clear();
      this.fonctionsService.launch_toast(true);
      this.cdr.detectChanges();
    } catch {
      this.translate.get('MESSAGE_INFO.RECORD_DELETED_ERROR').subscribe(
        (translation: string) => {
          this.fonctionsService.launch_toast(false, false, translation);
        }
      );
    }
  }
    getPicPPVFirstThree(record: VibrationData): number {
    const channels = record?.signalDataEntity?.signalData?.channels;
    if (channels && channels?.length > 0) {
      const firstThree = channels.slice(0, 3);
      return Math.max(
        ...firstThree.map(channel =>
          this.findMaxAbsValue(channel.timeSpectrum.ppvMin, channel.timeSpectrum.ppvMax)
        )
      );
    }
    const meta = record?.recordMetadata;
    const ppvs = [meta?.verticalPpv, meta?.longitudinalPpv, meta?.transversePpv]
      .filter(v => v != null && !Number.isNaN(Number(v))) as number[];
    if (ppvs.length > 0) {
      return Math.max(...ppvs.map(v => Math.abs(v)));
    }
    return meta?.picVibration ?? 0;
  }
    public findMaxAbsValue(min: number, max: number) {
    return Math.abs(max) > Math.abs(min) ? max : Math.abs(min);
  }
    getMaxFrequencyFirstThree(record: VibrationData): number {
    const channels = record?.signalDataEntity?.signalData?.channels;
    if (channels && channels?.length > 0) {
      const firstThree = channels.slice(0, 3);
      return Math.max(...firstThree.map(channel => channel.frequencySpectrum.maximumFrequencyHz));
    }
    return record?.recordMetadata?.maxFrequency ?? 0;
  }

}
